export const useDevice = () => {
    const isTouch = (): boolean => {
        return 'ontouchstart' in document.documentElement
    }
    return { isTouch }
}
